import { NavigationStates } from 'stores/app-bar-navigation-store';

import CoPilotTabPageController from './co-pilot-tab-page';

const ProjectsPageController = () => {
  return <CoPilotTabPageController tab={NavigationStates.PROJECTS} />;
};

export default ProjectsPageController;
